import { render, staticRenderFns } from "./AssetAdjustment.vue?vue&type=template&id=5cbf557b&"
import script from "./AssetAdjustment.vue?vue&type=script&lang=ts&"
export * from "./AssetAdjustment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbf557b')) {
      api.createRecord('5cbf557b', component.options)
    } else {
      api.reload('5cbf557b', component.options)
    }
    module.hot.accept("./AssetAdjustment.vue?vue&type=template&id=5cbf557b&", function () {
      api.rerender('5cbf557b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Reports/AssetAdjustment.vue"
export default component.exports